import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    icon: {
        width: '100%',
        maxWidth: theme.typography.pxToRem(600)
    }
}));
